<script setup lang="ts">
  import { incrementProfileProperty } from '~~/assets/js/newtabpage'
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'
  import { useAdMarketTile } from '~/composables/useAdmarketTiles'

  const tilesList = useAdMarketTile()

  const shortcutAdClick = async (index: 1 | 2 | 3 | 4 | 5, mostVisitedSiteName: string) => {
    await sendMixpanelEvent('NtpShortcutAd_Clicked', {
      ntp_tile_provider: 'admarketplace',
      ntp_tile_brand: mostVisitedSiteName,
      ntp_tile_position: index,
    })
    incrementProfileProperty('ntp_shortcutAdClicks', 1)
  }

  const vShortcutAd = {
    mounted: async (element: HTMLDivElement) =>
      sendMixpanelEvent('NtpShortcutAd_Rendered', {
        ntp_tile_provider: 'admarketplace',
        ntp_tile_brand: element?.dataset?.tileBrand as string,
        ntp_tile_position: element?.dataset?.tileIndex as unknown as 1 | 2 | 3 | 4 | 5,
      }),
  }
</script>
<template>
  <div class="flex w-full justify-center">
    <a
      v-for="(item, index) in tilesList"
      :key="item.id"
      v-shortcut-ad
      target="_blank"
      class="mb-[44px] flex h-[112px] w-[112px] flex-col items-center justify-center rounded-[4px] px-3 pt-[16px] no-underline hover:bg-[#2021241a] hover:no-underline dark:hover:bg-[#ffffff1a] 2xl:mb-[44px] 2xl:mt-[-13px]"
      :href="`${item.click_url + '&custom-data=outbrain'}`"
      :data-tile-index="index"
      :data-tile-brand="item.name"
      @click="shortcutAdClick(index as 1 | 2 | 3 | 4 | 5, item.name)"
    >
      <nuxt-img
        :alt="`${item.name}`"
        tabindex="-1"
        :src="`${item.image_url}`"
        width="46"
        height="46"
        class="mb-[12px] rounded-[50%] bg-[#f1f3f4] shadow-[0_1px_6px_-2px_rgba(0,0,0,0.25)]"
      />
      <p
        class="m-0 overflow-hidden text-ellipsis whitespace-nowrap text-center text-sm text-onelaunch_dark_shades_400 dark:text-radio_group_text_color_dark"
      >
        {{ item.name }}
      </p>
      <nuxt-img :src="`${item.impression_url}`" width="1" height="1" />
    </a>
  </div>
</template>
